import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';
import { media, mediaQuery } from '../../../common/styles/styleUtil';

const Kanit = 'Kanit, Helvetica Neue, Helvetica, Arial, sans-serif';
const Sarabun = 'Sarabun, Helvetica Neue, Helvetica, Arial, sans-serif';
const textStyle = css`
  margin: 16px 0;
  color: #333f48;
  font-size: 18px;
  line-height: 1.5;
  word-break: break-word;
`;

export const PostContentWrapper = styled.div`
  width: 100%;
  font-size: 18px;
  ${media.xs`
    padding: 0 16px;
  `};

  figure {
    width: 100% !important;
    max-width: 750px;
    margin: 32px 0;
    @media (${mediaQuery.tablet}) {
      max-width: 100% !important;
    }

    figcaption {
      font-size: 14px;
      font-weight: 300;
      line-height: 1.5;
      color: #697684;
    }
  }

  .figcaption {
    font-size: 16px;
    font-weight: 300;
    line-height: 1.5;
    color: #333f48;
    margin-top: -16px;
    display: block;
  }

  ul {
    padding-left: 16px;
  }

  img {
    width: 100%;
    max-width: 750px;
    height: auto;
    margin-bottom: 16px;

    &:nth-child(1n + 2) {
      margin-top: 16px;
    }

    @media (${mediaQuery.tablet}) {
      max-width: 100%;
    }
  }

  li {
    color: #333f48;
    margin-bottom: 8px;
  }

  ul {
    li {
      font-size: 18px;
      font-weight: 300;
    }
  }

  strong {
    ${textStyle};
    font-weight: bold;
  }

  p {
    ${textStyle};
    font-weight: 300;

    img {
      margin: 0;
    }

    &:first-of-type {
      margin: ${(props) => props.isReviewArticle && '40px 0 0'};
    }

    @media (${mediaQuery.tablet}) {
      font-size: 16px;
    }

    img {
      width: 100%;
      max-width: 750px;
      margin: 32px 0;
      height: auto;

      &:nth-child(1n + 2) {
        margin-top: 16px;
      }

      @media (${mediaQuery.tablet}) {
        max-width: 100%;
      }
    }

    iframe {
      width: 750px;
      height: 458px;
      @media (${mediaQuery.tablet}) {
        width: 100%;
        height: 458px;
      }
      ${media.xs`
        height: 209px;
      `};
    }
  }
`;

export const ItemWrapper = styled.div`
  position: relative;
  cursor: pointer;
`;

export const Image = styled.div`
  width: 750px;
  height: 500px;
  text-align: center;
  background-color: #333f48;
  @media (${mediaQuery.tablet}) {
    width: 100%;
    height: 439px;
  }

  ${media.xs`
    height: 229px;
  `}
  .lazy-image-wrapper {
    height: 100%;
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const DotBackground = styled.div`
  top: 229px;
  opacity: 0.5;
  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0), #000000);
  position: relative;
  width: 100%;
  height: 24px;
`;

export const Title = styled.div`
  margin-top: 32px;
  width: 750px;
  height: 30px;
  font-size: 20px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #333f48;
`;

export const PostContentContainer = styled.div`
  position: relative;
  font-family: ${Sarabun};
  .billboard {
    border: none;
  }

  .show-more-button {
    font-family: ${Kanit};
    margin-top: 16px;
    margin-bottom: 40px;

    ::before {
      content: '';
      position: absolute;
      z-index: 0;
      width: 100%;
      height: 80px;
      top: -95px;
      background-image: linear-gradient(
        to bottom,
        rgba(255, 255, 255, 0),
        rgba(255, 255, 255, 0.6) 60%,
        #ffffff 99%
      );
    }
  }

  a[href*='?attachment_id='] {
    pointer-events: none;
  }
`;

export const PostArticle = styled.div`
  ${ifProp(
    { isShowMore: true },
    css`
      max-height: ${(props) => props.maxHeight}px;
      overflow: hidden;
    `,
  )};

  .ant-affix {
    &:before {
      content: '';
      position: absolute;
      top: 0px;
      bottom: 0px;
      left: -299.9%;
      width: 300%;
      z-index: -1;
      background-color: #ffffff;
      border-bottom: 1px solid #d2d6da;
    }

    &:after {
      content: '';
      position: absolute;
      top: 0px;
      bottom: 0px;
      right: -299.9%;
      width: 300%;
      z-index: -1;
      background-color: #ffffff;
      border-bottom: 1px solid #d2d6da;
    }
  }

  .ant-anchor-wrapper {
    font-family: ${Kanit};
    display: ${(props) => (props.hasAnchor ? 'block' : 'none')};
    margin: 0;
    padding: 0;
    border-bottom: 1px solid #d2d6da;
    background-color: #ffffff;
    max-height: 100vh;
    display: block;
    scroll-behavior: smooth;
    scroll-padding: 0px;
    scrollbar-width:none
      ${media.xs`
      overflow: auto;
      white-space: nowrap;
      &::-webkit-scrollbar {
        display: none;
      }
     `}
      .ant-anchor {
      display: flex;
      flex-flow: nowrap;
      align-items: baseline;
      justify-content: flex-start;
      height: auto;

      .ant-anchor-ink {
        display: none;
      }

      .ant-anchor-link {
        display: inline-block;
        padding: 20px 8px 16px;
        margin-right: 16px;

        &:nth-child(2) {
          ${media.xs`
            padding-left: 16px;
          `}
        }

        .ant-anchor-link-title {
          font-size: 16px;
          font-weight: 400;
          line-height: 24px;
          color: #697684;
          transition: all 0.3s;

          &:hover {
            color: #2b6ed2;
          }
        }
      }
      .ant-anchor-link.cta-anchor {
        .ant-anchor-link-title {
          color: white;
          background-color: #ed2439f0;
          border-radius: 4px;
          padding: 0 5px;
        }
      }

      .ant-anchor-link-active {
        border-bottom: 2px solid #2b6ed2;
        padding-bottom: 14px;

        > .ant-anchor-link-title {
          color: #2b6ed2;
        }
      }
      &::-webkit-scrollbar {
        display: none;
      }
      .scrollable-tabs-container {
        max-width: 100%;
        overflow: hidden;

        .scroll_wrapper {
          overflow-x: auto;
          white-space: nowrap;
          display: -ms-flexbox;
          display: flex;
          scroll-behavior: smooth;
          scrollbar-width: none;
        }

        .right-arrow,
        .left-arrow {
          position: absolute;
          top: 10px;
          width: auto;
          display: none;
          pointer-events: auto;
          z-index: 1;
        }
        svg {
          width: 30px;
          height: 35px;
          padding: 5px;
          cursor: pointer;
          color: #000;
          border-radius: 50%;
          background-color: #8a7171b3;

          &:hover {
            background: #030202bd;
            color: white;
          }
        }

        .right-arrow {
          right: 0;
          background: transparent;
        }

        .left-arrow {
          left: 0;
          background: transparent;
        }
        .right-arrow.active,
        .left-arrow.active {
          display: flex;
        }
      }
    }
  }

  h2 {
    font-family: ${Kanit};
    margin: 40px 0 16px;
    font-size: 24px;
    font-weight: 500;
    line-height: 28px;
    color: #333f48;
    ${media.xs`
      padding: 0 16px;
    `}
  }

  h3 {
    font-family: ${Kanit};
    font-size: 20px;
    font-weight: 400;
    line-height: 26px;
  }

  .in-page-nav-description {
    p {
      ${textStyle};
      font-weight: 300;
    }
  }
`;

export const ContentHeroImageWrapper = styled.div`
  img {
    width: 100%;
    object-fit: cover;
    height: auto;
  }
`;

export const ShowMoreWrapper = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  background: #ffffff;
`;
export const FormContent = styled.div`
  margin-top: 20px;
  @media (${mediaQuery.mobile}) {
    margin-top: 20px;
    padding: 0 16px;
  }
`;
